<script lang="ts">
  import { Header } from '@widgets/header';
</script>

<div class="bg-default-50 font-neue text-default-900 dark:bg-store-dark dark:text-default-50">
  <Header />
  <main>
    <slot />
  </main>
</div>
